const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const T1 = bimg("photo-1519824145371-296894a0daa9", "top");
const I1 = bimg("photo-1600210492486-724fe5c67fb0", "entropy");
const I2 = bimg("photo-1615529182904-14819c35db37", "bottom");
const L1 = bimg("photo-1519710164239-da123dc03ef4", "faces");

export const THAI_POSTS = [
  {
    slug: "thai-massage-vs-regular-massage",
    title: "What Is Thai Massage — and How Does It Differ from Regular Massage?",
    keyword: "Thai massage vs regular massage",
    category: "Thai Massage & Your First Visit",
    read: "4 min read",
    img: I1,
    excerpt:
      "Clothes on, mat on the floor, and the therapist moves you. What makes Thai massage a different animal from table massage.",
    body: [
      {
        p: [
          "Thai massage is closer to assisted yoga than to a typical massage. You stay fully clothed, lie on a floor mat rather than a table, and the therapist uses hands, forearms and body weight to compress, stretch and gently rock you through a sequence of movements. There is no oil and no gliding strokes — the session is built from pressure and movement.",
        ],
      },
      {
        h: "The key differences",
        p: [
          "Table massage (Swedish, deep tissue) works muscles with oil through draping; Thai works the whole body through clothing, including joints and stretches. Table massage you receive; Thai you participate in, however passively — the therapist moves your limbs into positions you could not quite reach alone.",
        ],
      },
      {
        h: "Who tends to love it",
        p: [
          "People who feel stiff rather than sore, those who dislike undressing or oils, and anyone who wants to leave feeling lengthened and energized rather than melted. If you want stillness and oil, choose the table; if you want movement and space in the joints, Thai is a revelation.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "what-to-wear-to-thai-massage",
    title: "What to Wear to a Thai Massage",
    keyword: "what to wear to Thai massage",
    category: "Thai Massage & Your First Visit",
    read: "3 min read",
    img: L1,
    excerpt:
      "The one massage where your outfit matters. Simple clothing guidance for a session built on stretching.",
    body: [
      {
        p: [
          "Thai massage keeps you clothed — and since the session is built from stretches, compressions and gentle twists, what you wear actually shapes the experience.",
        ],
      },
      {
        h: "The dress code",
        p: [
          "Think yoga class, not spa robe: soft, stretchy clothing with full range of motion. Leggings or loose athletic pants, a t-shirt or light long-sleeve. Bare feet. Avoid jeans, belts, dresses, and anything with hard seams or hardware that would dig in during stretches.",
        ],
      },
      {
        h: "Small extras",
        p: [
          "Remove jewellery, tie back long hair loosely, and skip heavy meals in the hour before — you will be gently folded, and comfort is the whole point. Forgot proper clothes? Say so at booking; a looser, less stretch-heavy session can be arranged, or you can simply switch to a table massage that day.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "how-to-prepare-for-first-massage",
    title: "How to Prepare for Your First Massage Therapy Session",
    keyword: "how to prepare for first massage",
    category: "Thai Massage & Your First Visit",
    read: "4 min read",
    img: I2,
    excerpt:
      "Everything a first-timer quietly wonders: eating, timing, talking, pressure, and what happens if you fall asleep.",
    body: [
      {
        p: [
          "A first massage comes with a dozen small questions nobody wants to ask. Here are the honest answers.",
        ],
      },
      {
        h: "Before you arrive",
        p: [
          "Eat lightly an hour or two before, not right before. Arrive ten minutes early for the health form — it shapes the session. Have a rough answer ready for “what brings you in?”; even “everything hurts, I am tired” is a perfectly workable brief.",
        ],
      },
      {
        h: "During",
        p: [
          "Undress to your comfort level (underwear on is completely normal); you are draped throughout. Speak up about pressure — “softer” and “more there” are always welcome. Talking is optional; silence is never awkward. And if you fall asleep, that is not rude — it is the compliment therapists hope for.",
        ],
      },
      {
        h: "After",
        p: [
          "Rise slowly, drink water, keep the evening light if you can. Mild next-day tenderness after deeper work is normal and fades within a day or two.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "how-long-should-a-massage-be",
    title: "How Long Should a Massage Be — 30, 60, 75, 90 or 120 Minutes?",
    keyword: "how long should a massage be",
    category: "Thai Massage & Your First Visit",
    read: "3 min read",
    img: T1,
    excerpt:
      "The right length depends on the job. A quick guide to what each session length can honestly accomplish.",
    body: [
      {
        p: [
          "Session length is not about luxury — it is about what can realistically be done in the time. Here is the honest map.",
        ],
      },
      {
        h: "The lengths, decoded",
        p: [
          "30 minutes: one focused area — neck and shoulders, or the lower back. A maintenance tune-up, not a full story. 60 minutes: the standard — a full-body relaxation session or focused work on one region plus its neighbours. 75 minutes: the sweet spot for most people — thorough full-body work with real attention to a problem area. 90 minutes: unhurried, complete — full body plus detailed therapeutic work, the format where nothing is rushed. 120 minutes: a deep dive for complex, whole-body patterns.",
        ],
      },
      {
        h: "A simple rule",
        p: [
          "If you have a specific problem area, add time rather than intensity: 75 or 90 minutes at the right pressure changes more than 60 minutes of rushing. When in doubt, book 75.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "what-type-of-massage-should-i-get",
    title: "What Type of Massage Should You Get? A Simple Guide by Goal",
    keyword: "what type of massage should I get",
    category: "Thai Massage & Your First Visit",
    read: "4 min read",
    img: I1,
    excerpt:
      "Swedish, deep tissue, hot stone, sports, prenatal — matched to what you actually want fixed, in one minute.",
    body: [
      {
        p: [
          "Massage menus read like wine lists — and most people guess. Here is the whole decision, organized by what you want to be different afterwards.",
        ],
      },
      {
        h: "By goal",
        p: [
          "“I am exhausted and need to switch off” — Swedish relaxation or hot stone. “I have a specific knot or chronic tightness” — deep tissue or customized therapeutic. “I train hard and something is accumulating” — sports massage. “I am pregnant” — prenatal, positioned and adapted. “I feel stiff and want to be stretched out” — Thai. “My jaw clicks / I grind my teeth” — TMJ-focused work.",
        ],
      },
      {
        h: "The better answer",
        p: [
          "Or do not choose at all. At Royal Essence, sessions are customized by default: book any length, describe what is going on at the start, and the techniques are selected and combined for your body that day. The menu is a starting point, not a commitment.",
        ],
      },
    ],
    note: null,
  },
];
